export default "__VITE_ASSET__CQ_gm_5s__"